import React from 'react';
import { format } from 'date-fns';
import { useState, useContext, useEffect } from 'react';
import { ToolbarContext } from '../../contexts/toolbar-context';
import {IsoDatePicker} from "../../components/IsoDatePicker";
import {
    Accordion,
    AccordionActions,
    AccordionDetails,
    AccordionSummary, Button,
    FormControlLabel,
    Switch,
    TextField
} from "@mui/material";
import {DistributorSelect} from "../../components/MaterialSelects/DistributorSelect";
import {useSnackbar} from "notistack";
import {JobListReportMutationVariables, useJobListReportMutation} from "../../generated/graphql";
import { useDaybookContext } from '../../contexts/Daybook/DayBookContext';
import { RegionSelectGrouped } from '../../components/MaterialSelects/RegionSelectGrouped';

const JobList = () => {
    const [dateValue, setDateValue] = useState(format(new Date(), 'yyyy-MM-dd'));
    const [text, setText] = useState('');
    const [isWait, setWait] = useState(false);
    const [showOnGoing, setOnGoing] = useState(true);
    //const url = Config.phpUri + 'reports/job-list/' + dateValue + '/1';
    const [mutation] = useJobListReportMutation({ fetchPolicy: 'no-cache' });
    const toolbarContext = useContext(ToolbarContext);
    const daybookContext = useDaybookContext();
    const {enqueueSnackbar} = useSnackbar();
    useEffect(() => {
        toolbarContext.setPrimary(
          {
            primary: [],
            title: 'Daily Job List'
          });
      }, []);
    function setOnGoingEvt(evt) {
        setOnGoing(evt.target.checked);
    }
    function setDate(evt) {
        setDateValue(evt.target.value);
    }
    function setContent(evt) {
        setText(evt.target.value);
    }
    const [distributor,setDistributor] = useState(daybookContext?.jobListDefaultDistributor);
    const [regions,setRegions] = useState([]);
    function changeDistributor(evt) {
        console.log('CD',evt);
        setDistributor(evt.target.value);
    }
    function changeRegions(evt) {
        setRegions([...evt.target.value]);
    }
    async function submitForm() {
        if (isWait) return;
//        const toastKey = .show({message: 'Generating report', intent: 'primary', timeout: 0});
        enqueueSnackbar('Generating report');
        setWait(true);
        try {
            const vars:JobListReportMutationVariables = {date: dateValue, special_announcement: text, ongoing: showOnGoing};
            if(distributor) { vars.distributor = ''+distributor; }
            if(regions) { vars.regions = regions; }
            const data = await mutation({variables: vars});
            setWait(false);
            enqueueSnackbar('Rendering file',{color:'success'});
            const res = await fetch(data.data.jobListReport.reportData);
            const blobContent = await res.blob();
            const blobUrl = URL.createObjectURL(blobContent);
            window.open(blobUrl);
        } catch (e) {
            enqueueSnackbar('Fetch failed',{color:'error'});
            setWait(false);
        }
    }
    return (
        <Accordion defaultExpanded={true}>
            <AccordionSummary>Daily job list</AccordionSummary>
            <AccordionDetails>
                <form method="POST" target="_blank">
                    <div className="grid12">
                        <TextField label="Special Announcment" name="special-announcement" fullWidth={true} onChange={setContent} value={text} placeholder="Any special announcement text" multiline={true} />
                        <IsoDatePicker label="Date" name="date" value={dateValue} onChange={setDate} className="grid12-3"/>
                        <DistributorSelect label="Distributor" valueIsId={true} allowBlank={true} name="distributor" value={distributor} onChange={changeDistributor} className="grid12-5"/>
                        <RegionSelectGrouped label="Regions" multiple={true} valueIsId={true} allowBlank={true} name="regions" value={regions} onChange={changeRegions} className="grid12-5"/>
                        <FormControlLabel control={<Switch name="changes-only" checked={showOnGoing} onChange={setOnGoingEvt} />} label="On-going campaigns" className="grid12-12"/>
                    </div>
                </form>
            </AccordionDetails>
        <AccordionActions>
            <Button variant="contained" onClick={submitForm}>Generate Report</Button>
        </AccordionActions>
        </Accordion>);

}

export default JobList;